export default "__VITE_ASSET__b821d6d4__"